import script from "./artemisadsPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./artemisadsPagination.vue?vue&type=script&setup=true&lang=js"

import "./artemisadsPagination.vue?vue&type=style&index=0&id=6b05edf4&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b05edf4"]])

export default __exports__